import { useDeleteChannel } from '@/features/broadcasters/api/delete-channel';
import { ChannelType } from '@/features/broadcasters/types';
import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { FormTypeEnum } from '@/types';

type TParentBroadcastersControllersReturn = {
  parentBroadcasterDialog: ReturnType<typeof useDisclosureWithData<ChannelType>>;
  parentBroadcasterDrawer: ReturnType<
    typeof useDisclosureWithData<{ type: FormTypeEnum; data: ChannelType }>
  >;
  handleDeleteParentBroadcasters: () => void;
};

export function useParentBroadcastersControllers(): TParentBroadcastersControllersReturn {
  const parentBroadcasterDialog = useDisclosureWithData<ChannelType>();
  const parentBroadcasterDrawer = useDisclosureWithData<{
    type: FormTypeEnum;
    data: ChannelType;
  }>();
  const { mutate: deleteChannel } = useDeleteChannel();

  const handleDeleteParentBroadcasters = () => {
    if (parentBroadcasterDialog.data) {
      deleteChannel(
        {
          id: parentBroadcasterDialog.data.id,
        },
        {
          onSuccess: () => {
            parentBroadcasterDialog.close();
          },
        }
      );
    }
  };

  return {
    parentBroadcasterDialog,
    parentBroadcasterDrawer,
    handleDeleteParentBroadcasters,
  };
}
